import { numCommas } from "@/utils/numCommas";
import { memo } from "react";
import BedSvg from "../../../../public/assets/svg/property-card/BedSvg";
import BathSvg from "../../../../public/assets/svg/property-card/BathSvg";
import SizeSvg from "../../../../public/assets/svg/property-card/SizeSvg";

const BedBathSqft = ({ item }) => {
  const { size, lotSize } = item;
  const size_sqft =
    size && size.includes(",")
      ? size.replace(/[^0-9]/g, "")
      : size.indexOf(".") !== -1
        ? size.substring(0, size.indexOf("."))
        : size || (lotSize && lotSize.includes(","))
          ? lotSize.replace(/[^0-9]/g, "")
          : lotSize.indexOf(".") !== -1
            ? lotSize.substring(0, lotSize.indexOf("."))
            : lotSize;

  // Function to truncate number and add ellipsis
  const truncateNumber = (num) => {
    if (num && num.length > 9) {
      return num.substring(0, 9) + "...";
    }
    return num;
  };

  return (
    <div className="prop_details mb0">
      <span className="list-inline-item list-mr0">
        <BedSvg />
        <a href="#" className="BBS-text">
          {numCommas(item?.bedCount)} Beds
        </a>
      </span>

      <span className="list-inline-item list-mr0">
        <BathSvg />
        <a href="#" className="BBS-text">
          {numCommas(item?.bathCount)} Baths
        </a>
      </span>

      {size_sqft && (
        <span className="list-inline-item list-mr0">
          <SizeSvg />
          <a href="#" className="BBS-text">
            {truncateNumber(numCommas(size_sqft))} ft<sup>2</sup>
          </a>
        </span>
      )}
    </div>
  );
};

export default memo(BedBathSqft);
